module.exports = __webpack_public_path__ + "static/media/4564.cdf23925.jpg";